var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Lock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C8.6761905 1 6 3.6761905 6 7L6 10.392578L4.5 11.892578L4.5 18.105469L8.8925781 22.5L15.105469 22.5L19.498047 18.107422L19.498047 11.894531L18 10.394531L18 7C18 3.6761905 15.32381 1 12 1 z M 12 3C14.27619 3 16 4.7238095 16 7L16 8.3925781L15.107422 7.5L8.8925781 7.5L8 8.3925781L8 7C8 4.7238095 9.7238095 3 12 3 z M 12 12C13.1 12 14 12.9 14 14C14 14.735 13.594 15.372703 13 15.720703L13 19L11 19L11 15.720703C10.406 15.372703 10 14.735 10 14C10 12.9 10.9 12 12 12 z",
    fill: "#26260D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Lock1);
export default __webpack_public_path__ + "static/media/icons8_lock_1.a3772fe32df1e29c8061afe6d715c30c.svg";
export { ForwardRef as ReactComponent };